"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = require("../../Utilities");
var ProgressIndicator_base_1 = require("./ProgressIndicator.base");
var ProgressIndicator_styles_1 = require("./ProgressIndicator.styles");
/**
 * ProgressIndicator description
 */
exports.ProgressIndicator = Utilities_1.styled(ProgressIndicator_base_1.ProgressIndicatorBase, ProgressIndicator_styles_1.getStyles, undefined, { scope: 'ProgressIndicator' });
//# sourceMappingURL=ProgressIndicator.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/ProgressIndicator/ProgressIndicator.js
// module id = 1126
// module chunks = 0